



































import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";
import { useUrl } from "~/composables/Palmers";
import useTheme from "~/composables/useTheme";

export default defineComponent({
  name: 'CategoryGridItem',
  components: {
    PictureItem
  },
  props: {
    category: {
      type: Object,
      require: true
    },
    index: {
      type: Number,
      require: false
    }
  },
  setup() {
    const { getCategoryUrl } = useUrl();
    const { getCurrentTheme } = useTheme();
    const hover = ref(false);
    const isPalmersNew = computed(() => getCurrentTheme() === 'palmers_new');

    return {
      getCategoryUrl,
      hover,
      isPalmersNew
    }
  }
});
